<template>
  <van-image :src="url" @click="handleImagePreview">
    <template v-slot:loading>
      <van-loading type="spinner" size="20" />
    </template>
    <template v-slot:error>加载失败</template>
  </van-image>
</template>

<script>
import { ImagePreview } from 'vant';
export default {
  name: 'ShowImage',
  props: {
    url: { // 图片地址
      type: String,
      required: true
    }
  },
  data() {
    return {
      ImagePreviewInstance: null
    }
  },
  beforeDestroy() {
    if (this.ImagePreviewInstance) {
      this.ImagePreviewInstance.close();
    }
  },
  methods: {
    /**
     * 图片预览
     */ 
    handleImagePreview() {
      this.ImagePreviewInstance = ImagePreview({
        images: [this.url],
        closeable: true
      });
    }
  }
}
</script>
<style lang="less" scoped>
  .van-image { width: 100%; height: 100px; }
</style>